import {useCallback} from 'react';

import {FAILED_AUTH_INDEX} from '@web-catalog/const/numbers';

import {HeaderLinkProps} from '@web-catalog/types';

import {useAuthorizedProfile} from '@web-catalog/store/auth';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics';

export const useHeaderAnalytics = () => {
  const userInfo = useAuthorizedProfile();

  const logLinkClick = useCallback(
    (props: HeaderLinkProps) => {
      switch (props.title) {
        case 'Разработчикам':
          emitYmEvent({eventName: 'header_menu_button_developers'});

          logTmrEvent({
            logEvent: 'devTop.click',
            params: {
              vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
            },
          });

          break;

        case 'Игры':
          emitYmEvent({eventName: 'header_menu_button_games'});

          logTmrEvent({
            logEvent: 'gamesTop.click',
            params: {
              vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
            },
          });

          break;

        case 'Помощь':
          emitYmEvent({eventName: 'header_menu_button_help'});

          logTmrEvent({
            logEvent: 'supportTop.click',
            params: {
              vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
            },
          });

          break;

        case 'Приложения':
          emitYmEvent({eventName: 'header_menu_button_apps'});

          logTmrEvent({
            logEvent: 'appsTop.click',
            params: {
              vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
            },
          });

          break;
      }

      logTmrEvent({
        logEvent: 'header.click',
        params: {
          button_text: props.title,
          vk_id: userInfo?.id ?? FAILED_AUTH_INDEX,
        },
      });
    },
    [userInfo?.id],
  );

  return {
    logLinkClick,
  };
};
